"use strict";
// OAuth types for the MCP authorization server (plans/mcp-oauth.md).
// Follows OAuth 2.1, RFC 7636 (PKCE), RFC 8707 (resource indicators).
Object.defineProperty(exports, "__esModule", { value: true });
exports.MCP_OAUTH_SCOPE_READ = void 0;
// ===== MCP OAuth (plans/mcp-oauth.md) =====
//
// Server-only types for the MCP authorization server. They are never written
// by iOS and are exempt from domain-model parity (plan D16).
//
// Conventions for every type below:
// - Absent optional fields are omitted, never written as `null`.
// - Stored codes and refresh tokens never carry the raw secret. The document
//   ID is its SHA-256 hash (D6), so the type has no `code` / `token` field.
// - Dates are `Date` in code; the storage service converts to Firestore
//   Timestamps.
//
/** The only scope in version 1 (D9). `stash.write` arrives with write tools. */
exports.MCP_OAUTH_SCOPE_READ = 'stash.read';
